import { render } from "./InfoAppPreview.vue?vue&type=template&id=fc3561b8&scoped=true"
import script from "./InfoAppPreview.vue?vue&type=script&lang=js"
export * from "./InfoAppPreview.vue?vue&type=script&lang=js"

import "./InfoAppPreview.vue?vue&type=style&index=0&id=fc3561b8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fc3561b8"

export default script